//Anim existant hover desk in mobile
let akaAnimatedBtn = ()=> {
    const buttons = document.querySelectorAll('.btn');
    buttons.forEach((btn,index) => {
        let timeOutBtn = [];
        timeOutBtn[index] = null;
        btn.addEventListener('click',(event) => {
            let currentBtn = event.currentTarget;
            if(timeOutBtn[index]){
                clearTimeout(timeOutBtn[index]);
                currentBtn.classList.remove('animate-mobile-btn');
            }
            currentBtn.classList.add('animate-mobile-btn');
            timeOutBtn[index] = setTimeout(()=>{
                currentBtn.classList.remove('animate-mobile-btn');
            },500)
        });
    })
}
akaAnimatedBtn();

//Ripple EFFECT
const ripples = document.querySelectorAll('.ripple')
ripples.forEach(btn => {
    btn.addEventListener('click', (e) => {
        rippleEffect(e);
    });
})

let rippleEffect = (e) => {
    let targetElement = e.currentTarget;

    let x = e.offsetX
    let y = e.offsetY

    let ripplesSpan = document.createElement('span')
    ripplesSpan.style.left = x + 'px'
    ripplesSpan.style.top = y + 'px'
    ripplesSpan.classList.add('ripple-span')

    targetElement.classList.add('ripple-active')

    targetElement.appendChild(ripplesSpan)

    window.setTimeout(() => {
        ripplesSpan.remove()
        targetElement.classList.remove('ripple-active')
    }, 500)
}
window.rippleEffect = rippleEffect;